<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="list">
          <div class="form">
            <h2 class="subtitle-2">Add a section</h2>
            <div class="form__inner">
              <v-text-field
                v-model="listName"
                label="Section name"
                :hide-details="true"
                class="ma-0 mr-5"
                color="amber"
              ></v-text-field>
              <v-btn @click="addList" color="amber" class="ma-0" light
                >Add</v-btn
              >
            </div>
          </div>

          <h2 class="subtitle-2 mt-5 mt-5">Sections</h2>
          <draggable class="inner" group="outer" :list="doc.listNames">
            <architecture-col
              v-for="(item, index) in doc.listNames"
              :key="`list-${index}`"
              v-model="doc.list[item.name]"
              :title="item.title"
              :name="item.name"
              class="list__col"
              :hideIcons="false"
              @editList="onEditList"
              @showNote="showNote"
              @removeList="onRemoveList"
            ></architecture-col>
          </draggable>
        </div>

      </v-col>

      <v-col cols="12">
        <div class="list">
          <architecture-col
            v-model="doc.allItems"
            title="Proposed content"
            class="list__tray"
            :hideIcons="true"
          ></architecture-col>
        </div>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title
          class="headline"
          v-text="$t('exercise_service.saved.title')"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'add'">
        <v-card-title>Add note</v-card-title>

        <v-card-text>
          <activation-add @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card light v-if="dialogMode == 'show'">
        <v-card-text class="pa-10">
          <activation-show :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == 'edit'">
        <v-card-title class="headline">Edit note</v-card-title>

        <v-card-text>
          <activation-edit :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import draggable from "vuedraggable";
import { ArchitectureCol } from "@/views/user/exercises/architecture";

const fb = require("@/firebaseConfig.js");

export default {
  name: "ArchitectureStructure",
  data() {
    return {
      exercise : null,
      dialogMode: '',
      dialog: false,
      listName: "",
      // doc: {
      //   audience: {
      //     q1: [],
      //     q2: [],
      //     q3: [],
      //     q4: [],
      //     q5: [],
      //   },
      //   content: {
      //     q1: [],
      //     q2: [],
      //     q3: [],
      //     q4: [],
      //     q5: [],
      //   },
      //   list: {},
      //   listNames: [],
      //   allItems: [],
      // },
    }
  },
  props: {
    doc: Object,
  },
  components: {
    ArchitectureCol,
    draggable
  },
  watch: {
    doc: {
      deep: true,
      handler(val) {
        if (val) {
          this.saveExercise();
        }
      }
    }
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  mounted() {
    this.createList();
    this.getExercise();
  },
  methods: {
     getExercise() {
      console.log("get exercise");
      let uid = this.currentUser.uid;
      let ref = fb.structureExCollection
        .where("uid", "==", uid)
        .where("pid", "==", this.currentProjectModel.id);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
        });
        if (items.length) {
          this.exercise = items[0];
        }
      });
    },
     saveExercise() {
      // check if exercise exists
      let ref;
      let uid = this.currentUser.uid;
      // let vm = this;
      if (this.exercise == null) {
        console.log("no exercise");
        ref = fb.structureExCollection.doc();
      } else {
        console.log("has exercise", this.exercise.id);
        ref = fb.structureExCollection.doc(this.exercise.id);
      }
      ref
        .set({
          updatedOn: new Date(),
          id: ref.id,
          uid: uid,
          pid: this.currentProjectModel.id,
          doc: this.doc,
        })
        .then(() => {
          // this.exercise = this.doc;
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
    addIdea() {
      this.dialogMode = "add";
      this.dialog = true;
    },
    getResults(doc) {
      this.pushToArray(doc.audience, "audience", "grey lighten-3");
      this.pushToArray(doc.benefits, "benefits", "grey lighten-3");
      this.pushToArray(doc.features, "features", "grey lighten-3");
      this.pushToArray(doc.reasons, "reasons", "grey lighten-3");
    },
    pushToArray(arr, model, color) {
      if (arr || arr.length > 0 || arr != undefined) {
        arr.forEach((y) => {
          this.results[model].push({ title: y, color: color });
        });
      }
    },
    addList() {
      // let l = Object.keys(this.doc.list).length + 1;
      let lc = this.listName.replace(/\s/g, "").toLowerCase();
      this.doc.listNames.push({ title: this.listName, name: lc });
      this.listName = "";
      this.$set(this.doc.list, lc, []);
    },
    onRemoveList(name) {
      // loop through elements in list and re-distribute to master list
      let items = [];
      Object.values(this.doc.list[name]).forEach((x) => {
        items.push(x);
      });
      this.doc.allItems = [...this.doc.allItems, ...items];
      let item = this.doc.listNames.find((x) => x.name === name);
      let index = this.doc.listNames.indexOf(item);
      this.doc.listNames.splice(index, 1);
      this.$delete(this.doc.list, name);
    },
    onEditList(params) {
      console.log(params);
      let item = this.doc.listNames.find((x) => x.name === params.oldName);
      let index = this.doc.listNames.indexOf(item);
      console.log(index);
      let lc = params.newTitle.replace(/\s/g, "").toLowerCase();
      let renamedItem = {
        title: params.newTitle,
        name: lc,
      };
      this.$set(this.doc.listNames, index, renamedItem);

      let obj = this.doc.list[params.oldName];
      delete this.doc.list[params.oldName];
      this.$set(this.doc.list, lc, obj);
    },
    clone(obj) {
      Object.assign({}, obj);
    },
    renameKey(object, key, newKey) {
      const clonedObj = this.clone(object);
      const targetKey = clonedObj[key];
      delete clonedObj[key];
      clonedObj[newKey] = targetKey;
      return clonedObj;
    },
    addNote() {
      this.dialogMode = "add";
      this.dialog = true;
    },
    editNote($event) {
      console.log("edit note", $event);
      this.dialogMode = "edit";
      this.cardId = $event;
      this.dialog = true;
    },
    showNote($event) {
      console.log("show note", $event);
      this.dialogMode = "show";
      this.cardId = $event;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
    },
    createList() {
      let items = [];
      Object.values(this.doc.audience).forEach((value) => {
        value.forEach((x) => {
          x.value = value,
          x.color = "blue lighten-4";
          items.push(x);
        });
      });
      Object.values(this.doc.content).forEach((value) => {
        value.forEach((x) => {
          x.value = value,
          x.color = "lime accent-1";
          items.push(x);
        });
      });
      let itemsFromList = [];
      Object.values(this.doc.list).forEach((value) => {
        value.forEach((x) => {
          x.value = value,
          itemsFromList.push(x);
        });
      });
      let all = [];
      items.forEach((x) => {
        if (!itemsFromList.some((y) => y.title == x.title)) {
          all.push(x);
        }
      });
      this.doc.allItems = all;
    },
  },
};
</script>

<style lang="scss"></style>
